enum DiscussionSubjectTypes {
  TASK = "TASK",
  LIST = "ACTIVITY",
  MILESTONE = "MILESTONE",
  EVENT = "EVENT",
  PROJECT = "PROJECT",
}

export { DiscussionSubjectTypes };
